import React from "react";

const DraggableDiv = ({ divNumber, idImage, linkImage, nameImage, urlImage, descImage, contentOrder, language, lang, handleDrag, handleDragOver, handleDrop, handleRemove, handleEdit, handleChangeContentMediaImage }) => {
  let link = linkImage
  if(linkImage !== undefined && linkImage.includes('youtube')) {
    let aux = link.split("?v=");
    link = 'https://img.youtube.com/vi/' + aux[1] + '/0.jpg'
  }

  return (
    <>
      <div 
        draggable={true}    
        id={idImage} 
        data-link={linkImage}

        onDragStart={handleDrag}
        onDragOver={handleDragOver}
        onDrop={handleDrop}

        className="col-4 col-sm-3 mb-5 position-relative"
      >
        <div className="position-absolute end-0 rounded-0 me-3 mt-1">
          <span 
            className="btn btn-icon btn-active-color-primary me-1 rounded-0 border-0 bg-white border shadow"
            data-kt-image-input-action="remove"
            data-bs-dismiss="click"
            //onClick={handleEdit}
            data-bs-toggle="modal" 
            data-bs-target={"#edit_modal_" + contentOrder + "_" + divNumber}
            title="Edit"
          >
            <i className="bi bi-pencil"></i>
          </span>
          <span 
            className="btn btn-icon btn-active-color-primary rounded-0 border-0 bg-white border shadow"
            data-kt-image-input-action="remove"
            data-bs-toggle="tooltip"
            data-bs-dismiss="click"
            title="Remove"
            onClick={handleRemove}
          >
            <i className="bi bi-x-lg"></i>
          </span>
        </div>
        <img className="img-fluid border" data-order={contentOrder} data-id={idImage} data-link={linkImage} src={link} alt="" />
        <input type="text" name="name" className="form-control border-top-0 rounded-0" value={nameImage} data-order={contentOrder} data-lang={lang} data-id={divNumber} data-imageid={idImage} data-link={linkImage} onChange={handleChangeContentMediaImage} /*readOnly={true} disabled={true}*/ />
      </div>

      <div className="modal bg-light fade" tabIndex="-1" id={"edit_modal_" + contentOrder + "_" + divNumber}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
              <div className="modal-header">
                  <h5 className="modal-title">{nameImage}</h5>

                  <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                    <i className="bi bi-x fs-2"></i>
                  </div>
              </div>

              <div className="modal-body">
                <div className="row mb-6">
                  <div className="col-12 col-sm-6">
                    <img className="img-fluid" alt="" src={link} /> 
                  </div>
                </div>
                <div className="row mb-6">
                  <div className="col-12">
                    <label className="col-form-label fw-bold fs-6">{language[lang].title}</label>
                    <input type="text" className="form-control mb-3" name="name" value={nameImage} data-order={contentOrder} data-lang={lang} data-id={idImage} data-link={linkImage} onChange={handleChangeContentMediaImage} placeholder={"Nome"} /> 
                  </div>
                </div>
                <div className="row mb-6">
                  <div className="col-12">
                    <label className="col-form-label fw-bold fs-6">URL</label>
                    <input type="text" className="form-control mb-3" name="url" defaultValue={urlImage} data-order={contentOrder} data-lang={lang} data-id={idImage} data-link={linkImage} onBlur={handleChangeContentMediaImage} placeholder={"URL"} /> 
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <label className="col-form-label fw-bold fs-6">{language[lang].description}</label>
                    <textarea type="text" className="form-control" name="description" value={descImage} data-order={contentOrder} data-lang={lang} data-id={idImage} data-link={linkImage} onChange={handleChangeContentMediaImage} placeholder={"Legenda"} /> 
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                  <button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
                  <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleEdit}>{language[lang].save}</button>
              </div>
          </div>
        </div>
      </div>
  </>
  );
};

export default DraggableDiv;
